"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Textbox.css");
var Utils = require("player-core/utils");
var Textbox = (function (_super) {
    __extends(Textbox, _super);
    function Textbox(props) {
        var _this = _super.call(this, props) || this;
        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }
    Textbox.prototype._onChange = function (event, id) {
        var value = event.target.value;
        this.props.onChange ? this.props.onChange(value, id) : null;
    };
    Textbox.prototype.componentWillReceiveProps = function (props) {
        if (this.props.value !== props.value) {
            this.setState({
                value: props.value
            });
        }
    };
    Textbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, ariaLabeledBy = _a.ariaLabeledBy, label = _a.label, description = _a.description, errorMessage = _a.errorMessage, height = _a.height, id = _a.id, showLabel = _a.showLabel, isEnabled = _a.isEnabled, isRequired = _a.isRequired, maxLength = _a.maxLength, placeholder = _a.placeholder, tag = _a.tag, type = _a.type, width = _a.width, value = _a.value;
        var cssOuter = ['p-textbox', 'form-row'];
        var cssInput = ['p-bc-grey60', 'p-bg-hv-white', 'p-bc-f-blue50', 'p-ph-grey50'];
        var attrRow = 0;
        if (height) {
            var cases = {
                'Xsmall': {
                    className: 'row-1',
                    rows: 0
                },
                'Small': {
                    className: 'row-3',
                    rows: 3
                },
                'Medium': {
                    className: 'row-6',
                    rows: 6
                },
                'Large': {
                    className: 'row-9',
                    rows: 9
                }
            };
            attrRow = cases[height].rows;
            cssInput.push(cases[height].className);
        }
        var Elem = attrRow > 1 ? 'textarea' : 'input';
        var attr = {};
        if (maxLength > 0)
            attr['maxLength'] = maxLength;
        var accessibilityAttrInput = {};
        if (isRequired) {
            accessibilityAttrInput['aria-required'] = true;
            cssOuter.push('is-required');
        }
        if (!isEnabled) {
            accessibilityAttrInput['aria-disabled'] = true;
            cssOuter.push('is-disabled');
        }
        if (errorMessage) {
            accessibilityAttrInput['aria-invalid'] = true;
            cssOuter.push('is-invalid');
            cssInput.push('p-b-error', 'p-bc-error50');
        }
        if (!showLabel) {
            cssOuter.push('label-hidden');
        }
        if (width) {
            var cases = {
                'Xsmall': 'xsmall',
                'Small': 'small',
                'Medium': 'medium',
                'Large': 'large',
                'Xlarge': 'xlarge',
                'Auto': 'auto',
                'Block': ' block'
            };
            cssInput.push(cases[width]);
        }
        return (React.createElement("div", { className: cssOuter.join(" "), "data-tag": tag },
            React.createElement("label", { htmlFor: id, className: "p-t-grey40" },
                label,
                isRequired ?
                    React.createElement("span", { className: 'p-t-error50' }, "*") :
                    null),
            React.createElement("div", { className: "p-input-wrapper" },
                React.createElement(Elem, __assign({ className: cssInput.join(" "), id: id, rows: attrRow, type: type, value: value, onChange: function (e) { return _this._onChange(e, id); }, required: isRequired, disabled: !isEnabled, placeholder: placeholder, "aria-label": ariaLabel, "aria-labelledby": ariaLabeledBy }, attr, accessibilityAttrInput)),
                (description || errorMessage) && React.createElement("div", null,
                    description && React.createElement("p", { className: 'note' }, description),
                    errorMessage ?
                        React.createElement("p", { className: 'error p-t-error50' }, errorMessage) :
                        null))));
    };
    return Textbox;
}(React.Component));
Textbox.defaultProps = {
    id: 'inp' + Utils.createUUID(),
    label: 'Label',
    value: '',
    placeholder: null,
    errorMessage: '',
    description: '',
    width: 'Block',
    type: 'Text',
    height: 'Xsmall',
    isRequired: false,
    showLabel: true,
    isEnabled: true,
    onChange: void (0),
    maxLength: 0,
    tag: null,
    ariaLabel: null,
    ariaLabeledBy: null
};
exports.Textbox = Textbox;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['editor-controls'])
        csod.engine.controls['editor-controls'] = {};
    csod.engine.controls['editor-controls']['Textbox'] = Textbox;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Textbox"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-editor-controls/controls/Textbox/index.js
// module id = 780
// module chunks = 0